// apps/client/src/hooks/useTrackEvent.ts
// Dual-track event logging: PostHog (dashboards) + Firestore (backend alerting)

import { useCallback } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { useAuth } from '../context/AuthContext';
import { posthog } from '../providers/PostHogProvider';

export function useTrackEvent() {
  const { user, claims } = useAuth();

  const trackEvent = useCallback((event: string, properties?: Record<string, any>) => {
    const enriched = {
      ...properties,
      companyId: claims?.companyId,
    };

    // PostHog (dashboards, funnels, cohorts)
    try {
      posthog?.capture(event, enriched);
    } catch {} // Never throw on tracking

    // Firestore (backend alerting, custom queries)
    addDoc(collection(db, 'activity_logs'), {
      event,
      userId: user?.uid,
      email: user?.email,
      companyId: claims?.companyId,
      properties: properties || {},
      timestamp: serverTimestamp(),
    }).catch(() => {}); // Fire-and-forget
  }, [user, claims]);

  return { trackEvent };
}
